// VoK MUI Base Styles
import borders from "app/assets/theme-dark/base/borders";

// VoK MUI Helper Functions
import pxToRem from "app/assets/theme-dark/functions/pxToRem";

const {borderRadius} = borders;

const cardMedia = {
    styleOverrides: {
        root: {
            borderRadius: borderRadius.xl,
            margin: `${pxToRem(16)} ${pxToRem(16)} 0`,
        },

        media: {
            width: "auto",
        },
    },
};

export default cardMedia;
